module.exports = __webpack_public_path__ + "img/img-hotline@2x.d071b1d1.png";